import React, {useState, useEffect} from "react";
import ForgotPassword from "./ForgotPassword";
import TextField from "../../Components/TextField";
import ButtonContainer from "../../Components/ButtonContainer";
import COLORS from '../../Colors';
import "../../Styles/Signin.css";
import * as Constants from '../../Utilities/Constants';

import { CognitoHelper } from '../../Utilities/CognitoHelper';

export default function SignIn() {

    const [login, setLogin] = useState(true); // sets whether the login or signup screen is up
    const [forgotPass, setForgotPass] = useState(false);
    const [focused, focusSet] = useState(false)

    useEffect(() => {
        focusEmail()
    });

    let signupFields = {
        'email' : {
            "title": "Email",
            "placeholder": "Enter your email address",
            "id": "signupEmail",
            "type": "text",
            "focus": true
        },
        'password' : {
            "title": "Password",
            "placeholder": "Enter a password",
            "id": "signupPassword",
            "type": "password",
        },
        'confirm' : {
            "title": "Confirm Password",
            "placeholder": "Re-enter your password",
            "id": "signupConfirm",
            "type": "password",
        },
        'secret' : {
            "title": "Secret Key",
            "placeholder": "Enter the Secret Key from your administrator",
            "id": "secretKey",
            "type": "password",
        },
    }

    const signupKeys = [Constants.EMAIL, Constants.PASS, Constants.CONFIRM, Constants.SECRET]
    const loginKeys = [Constants.EMAIL, Constants.PASS]
    let keys = login ? loginKeys : signupKeys

    let errorMessages = {
        "missingEmail" : "Please enter an email address",
        "missingPassword" : "Please enter a password",
        "missingConfirm" : "Please re-enter your password",
        "incorrectConfirm" : "Please ensure that the passwords match",
        "missingSecret" : "Please enter the secret key from your administrator",
        "incorrectSecret" : "Please enter the correct secret key"
    }

    const [currentErrors, setErrors] = useState({});

    const clear_errors = (id) => {
        if(currentErrors[id]) {
            let newErrors = {...currentErrors}
            delete newErrors[id]
            setErrors(newErrors)
        }
    }

    let signupInput = keys.map(function(key, index){
        let field = signupFields[key]
        let fieldKey = field.id + currentErrors

        return(
            <TextField
                frontLabel = {field.title}
                id = {field.id}
                placeholder = {field.placeholder}
                update_text = {() => clear_errors(field.id)}
                type={field.type}
                small = {true}
                bare = {true}
                key={fieldKey}
                readOnly={false}
                error = {currentErrors[field.id]}
                focus = {field.focus === true}
            />
        )

    });

    let signin = <div>
        {signupInput}
    </div>

    // gets the secret key from the database
    const getSecretKey = async () => {
        return process.env.REACT_APP_APP_SIGN_IN_SECRET;
    }

    //Checks for errors in the sign-in fields before sending a login request
    const getSignInErrors = async (email, password, confirmPass, secretKey) => {
        await setErrors({})

        let newErrors = {}
        if(!email) {
            newErrors[signupFields[Constants.EMAIL].id] = errorMessages.missingEmail
        }
        if(!password) {
            newErrors[signupFields[Constants.PASS].id] = errorMessages.missingPassword
        }

        if(!login){
            if(!confirmPass) {
                newErrors[signupFields[Constants.CONFIRM].id] = errorMessages.missingConfirm
            }

            if(!secretKey) {
                newErrors[signupFields[Constants.SECRET].id] = errorMessages.missingSecret
            }


            if(!newErrors[signupFields[Constants.CONFIRM].id] && password !== confirmPass){
                newErrors[signupFields[Constants.CONFIRM].id] = errorMessages.incorrectConfirm
            }

            if(!newErrors[signupFields[Constants.SECRET].id]){
                let actualSecretKey = await getSecretKey();
                if(secretKey !== actualSecretKey){
                   newErrors[signupFields[Constants.SECRET].id] = errorMessages.incorrectSecret
                }
            }
        }

        setErrors(newErrors)
        return(newErrors)
    }

    // Gets relevant errors returned from the login request
    const addError = (loginErrors, errorMsg) => {
        let msg = String(errorMsg).toLowerCase()
        if(msg.includes('password')){
            let newError = {}
            newError[signupFields[Constants.PASS].id] = errorMsg
            setErrors({...loginErrors, ...newError})
        }
        if(msg.includes('email') || msg.includes('identifier')){
            let newError = {}
            newError[signupFields[Constants.EMAIL].id] = errorMsg
            setErrors({...loginErrors, ...newError})
        }
    }

    // Ensures email field is the field zoomed into on the ipad
    const focusEmail = () => {
        if(!focused) {
            let email = document.getElementById("signupEmail");
            email.focus();
            focusSet(true);
        }
    }

    // After user presses the sign-in button
    const signInClicked = async () => {
        let email = document.getElementById("signupEmail").value.toLowerCase();
        let password = document.getElementById("signupPassword").value;
        let confirmPass = login ? "" : document.getElementById("signupConfirm").value;
        let secretKey = login ? "" : document.getElementById("secretKey").value;

        let loginErrors = await getSignInErrors(email, password, confirmPass, secretKey);

        if (Object.keys(loginErrors).length !== 0){
            console.log("errors")
            console.log(loginErrors)
            return;
        }

        const cognitoHelper = new CognitoHelper()

        if (login) { //User already has an account
            cognitoHelper.signIn(email, password, function(user) {
                console.log(`Signed in as ${user}.`)

                window.location.reload()
            }, function(error) {
                alert('Unable to login. Please check your e-mail address and password.')

                console.log(error) // Note: this is an object, not a string
                addError(loginErrors, error)
            })
        } else { //Sign-up, user is creating an account
            cognitoHelper.createUser(email, password, function(user) {
                console.log("Signed up!")

                alert('Your account has been created. Check your e-mail for a verification message.\n\nOnce you verify your e-mail address, you may return here to login.')

                window.location.reload()
            }, function(error) {
                alert('Unable to sign up. Please check that your e-mail address is valid and passwords match.')

                console.log(error)
                addError(loginErrors, error)
            })
        }
    }

    let switchButtonText = login ? "Need to create an account?" : "Already have an account?"

    const loginElements = <div className="loginStack">
        <div className="logo">
            <img src="logo512.png" alt='RACS logo'/>
            <h1>RACS</h1>
        </div>

        {signin}

        {login ?
            <button className="forgotPass" style={{color:`${COLORS.blue}`}} onClick={() => setForgotPass(true)} >
            Forgot password?
            </button> : null
        }

        <ButtonContainer
            colors={[COLORS.blue]}
            buttonTexts={[login ? "Login" : "Sign Up"]}
            buttonType='filled'
            onClick={signInClicked}
        />

        <div className="switchButton">
            {switchButtonText}
        <button onClick={() => {setLogin(!login); setErrors({}); focusSet(false);}  } ><p style={{color:`${COLORS.blue}`}}>{login ? "Sign Up" : "Login"}</p></button>
        </div>

    </div>

    return (
        forgotPass ? <ForgotPassword goBack={() => setForgotPass(false)} /> : loginElements
    );
}
